import React from "react";

import SeriesItem from "./SeriesItem";

import classes from "./SeriesList.module.css";
import { TvShow } from "src/types/tvSeriesData";

type Props = {
  shows: TvShow[];
};
const SeriesList = ({ shows }: Props) => (
  <div className={classes.wrapper}>
    {shows.map((show) => (
      <SeriesItem showsData={show} key={show.id} />
    ))}
  </div>
);

export default SeriesList;
